import React, {useContext, useState} from "react";
import {useHistory} from "react-router-dom";
import styles from "./nodeProfile/NodeProfile.module.scss";
import ProcessMapNodeProfile from "./nodeProfile/ProcessMapNodeProfile";
import ProcessCompareNodeProfile from "./nodeProfile/ProcessCompareNodeProfile";
import AppContext from "./../../../context/appContext"
const NodeProfile = ({ index, data, dataGraph, closeProfile, showNodeProfile }) => {
    const context = useContext(AppContext)
    const history = useHistory();
    const [selectedView, setSelectedView] = useState({
        averageDuration: "avg_duration",
        averageDurationSec: "avg_duration_sec",
        caseFrequency: "case_frequency",
        rework: "loop",
        cost: "avg_cost",
    });
    const [selectedFilter, setSelectedFilter] = useState(null);

    const views = [
        {
            id: 1,
            title: "Frequency",
            value: "caseFrequency",
            secValue: "caseFrequency",
            icon: <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.0666 8.00097C14.0666 11.3512 11.3496 14.0666 7.99893 14.0666C4.6485 14.0666 1.93331 11.3514 1.93331 8.00097C1.93331 4.64832 4.64862 1.93325 7.99893 1.93325C11.3495 1.93325 14.0666 4.64856 14.0666 8.00097Z" stroke="#FAFCFF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>,
            items: [
                {
                    id: 1,
                    title: "Case Count",
                    value: "case_frequency"
                },
                {
                    id: 2,
                    title: "Total",
                    value: "total_frequency"
                },
            ]
        },
        {
            id: 2,
            title: "Duration",
            value: "averageDuration",
            secValue: "averageDurationSec",
            icon: <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1665 8.00041C14.1665 11.4064 11.4059 14.1671 7.99986 14.1671C4.59386 14.1671 1.83319 11.4064 1.83319 8.00041C1.83319 4.59441 4.59386 1.83374 7.99986 1.83374C11.4059 1.83374 14.1665 4.59441 14.1665 8.00041Z" stroke="#FAFCFF" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.2876 9.96211L7.77423 8.46278V5.23145" stroke="#FAFCFF" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>,
            items: [
                {
                    id: 1,
                    title: "Avg",
                    sec: "avg_duration_sec",
                    value: "avg_duration"
                },
                {
                    id: 2,
                    title: "Min",
                    sec: "min_duration_sec",
                    value: "min_duration"
                },
                {
                    id: 3,
                    title: "Max",
                    sec: "max_duration_sec",
                    value: "max_duration"
                },
                {
                    id: 4,
                    title: "Total",
                    sec: "total_duration_sec",
                    value: "total_duration"
                },

            ]
        },
        {
            id: 3,
            title: "Rework",
            value: "rework",
            secValue: "rework",
            icon: <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.0666 8.00097C14.0666 11.3512 11.3496 14.0666 7.99893 14.0666C4.6485 14.0666 1.93331 11.3514 1.93331 8.00097C1.93331 4.64832 4.64862 1.93325 7.99893 1.93325C11.3495 1.93325 14.0666 4.64856 14.0666 8.00097Z" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7.0367 11.1946L7.15141 11.0979L7.0367 11.1946L7.7378 12.0267C7.7378 12.0267 7.73781 12.0267 7.73781 12.0267C7.8055 12.107 7.90164 12.15 8.00003 12.15C8.08496 12.15 8.16901 12.1179 8.23479 12.0557L8.23485 12.0556C8.37457 11.9233 8.38554 11.7005 8.26211 11.5541L7.97948 11.2186H7.99996C9.92897 11.2186 11.4833 9.55757 11.4833 7.53432C11.4833 5.51104 9.92897 3.85 7.99997 3.85C6.07098 3.85 4.51663 5.51104 4.51663 7.53432C4.51663 7.72453 4.66415 7.89395 4.86433 7.89395C5.06452 7.89395 5.21204 7.72451 5.21204 7.53432C5.21204 5.89111 6.47098 4.56927 7.99996 4.56927C9.52894 4.56927 10.7879 5.89112 10.7879 7.53432C10.7879 9.1775 9.52894 10.4994 7.99996 10.4994H7.97948L8.26211 10.1639C8.38555 10.0174 8.37454 9.7947 8.23486 9.66236C8.09003 9.52514 7.86545 9.53979 7.73781 9.69128L7.85252 9.78793L7.73781 9.69128L7.0367 10.5234L7.15141 10.62L7.0367 10.5234C6.87488 10.7155 6.87488 11.0025 7.0367 11.1946Z" fill="white" stroke="white" stroke-width="0.3"/>
                </svg>,
            items: [
                {
                    id: 1,
                    title: "Loops",
                    value: "loop"
                },
                {
                    id: 2,
                    title: "Self-Loops",
                    value: "self_loop"
                },
            ]
        },
        !context.handleDisableCostProperty() && {
            id: 4,
            title: "Cost",
            value: "cost",
            secValue: "cost",
            icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="9.4" fill="#ffffff" fill-opacity="0.2" stroke="#ffffff" stroke-width="1.2"></circle>
                <g clipPath="url(#clip0_4074_38629)">
                    <path d="M10.9661 6C11.3728 6.00039 11.7628 6.16214 12.0504 6.44973C12.338 6.73733 12.4997 7.12728 12.5001 7.534C12.5001 7.6666 12.5528 7.79378 12.6466 7.88755C12.7403 7.98132 12.8675 8.034 13.0001 8.034C13.1327 8.034 13.2599 7.98132 13.3537 7.88755C13.4474 7.79378 13.5001 7.6666 13.5001 7.534V7.5C13.5001 7.4905 13.5001 7.482 13.5001 7.4725C13.4834 6.81136 13.2092 6.18289 12.7358 5.72102C12.2625 5.25916 11.6275 5.00044 10.9661 5H10.5001V4.5C10.5001 4.36739 10.4474 4.24021 10.3537 4.14644C10.2599 4.05267 10.1327 4 10.0001 4C9.86751 4 9.74034 4.05267 9.64657 4.14644C9.5528 4.24021 9.50012 4.36739 9.50012 4.5V5H9.03412C8.43278 5.00064 7.85127 5.21511 7.39352 5.60509C6.93577 5.99506 6.63163 6.53511 6.53545 7.12871C6.43927 7.72231 6.55733 8.33077 6.86852 8.84533C7.17971 9.35989 7.66375 9.74701 8.23412 9.9375L9.50012 10.36V14H9.03412C8.6274 13.9996 8.23745 13.8379 7.94986 13.5503C7.66226 13.2627 7.50052 12.8727 7.50012 12.466C7.50012 12.3334 7.44744 12.2062 7.35368 12.1124C7.25991 12.0187 7.13273 11.966 7.00012 11.966C6.86751 11.966 6.74034 12.0187 6.64657 12.1124C6.5528 12.2062 6.50012 12.3334 6.50012 12.466V12.5C6.50012 12.5095 6.50012 12.518 6.50012 12.5275C6.51681 13.1886 6.79105 13.8171 7.2644 14.279C7.73776 14.7408 8.37278 14.9996 9.03412 15H9.50012V15.5C9.50012 15.6326 9.5528 15.7598 9.64657 15.8535C9.74034 15.9473 9.86751 16 10.0001 16C10.1327 16 10.2599 15.9473 10.3537 15.8535C10.4474 15.7598 10.5001 15.6326 10.5001 15.5V15H10.9661C11.5675 14.9994 12.149 14.7849 12.6067 14.3949C13.0645 14.0049 13.3686 13.4649 13.4648 12.8713C13.561 12.2777 13.4429 11.6692 13.1317 11.1547C12.8205 10.6401 12.3365 10.253 11.7661 10.0625L10.5001 9.64V6H10.9661ZM11.4511 11.0105C11.7968 11.1256 12.0903 11.3599 12.279 11.6716C12.4677 11.9833 12.5392 12.352 12.4809 12.7117C12.4225 13.0713 12.2381 13.3985 11.9605 13.6345C11.683 13.8706 11.3305 14.0001 10.9661 14H10.5001V10.6935L11.4511 11.0105ZM9.50012 9.3065L8.55012 8.9895C8.20449 8.87446 7.91108 8.64018 7.72239 8.32859C7.5337 8.01699 7.46206 7.64842 7.52027 7.28883C7.57849 6.92924 7.76277 6.60211 8.04014 6.36597C8.3175 6.12983 8.66985 6.0001 9.03412 6H9.50012V9.3065Z" fill="#ffffff"></path>
                </g>
                <defs>
                    <clipPath id="clip0_4074_38629">
                        <rect width="12" height="12" fill="white" transform="translate(4 4)"></rect>
                    </clipPath>
                </defs>
            </svg>,
            items: [
                {
                    id: 2,
                    title: "Average",
                    value: "avg_cost"
                },
                {
                    id: 1,
                    title: "Total",
                    value: "total_cost"
                },
            ]
        },
    ].filter(item => item)

    const filters = ["Starting", "Ending", "With", "Without"];

    let title, level, caseFrequency = '';
    if (data) {
        if (history.location.pathname === "/process-compare" && data[index].node_side === "both") {
            title = data[index].name;
        } else {
            title = data[index].name;
            level = data[index].total_frequency.thickness;
            caseFrequency = data[index].case_frequency.value;
        }
    }

    const mapFiltersName = {
        Starting: "start",
        Ending: "end",
        With: "with",
        Without: "without",
    }

    const handleSetSelectedFilter = (filter, title) => {
        setSelectedFilter(filter);
        // Pass filter to hessan
        let activeFilters = {filters: mapFiltersName[filter], activity_name: title}
        if(history.location.pathname === "/process-compare")
         context.dispatch({type:'set_process_compare_active_filters',value:activeFilters});
        if(history.location.pathname === "/variant-explorer")
         context.dispatch({type:'set_process_map_active_filters',value:activeFilters});
        if(history.location.pathname === "/process-explorer")
         context.dispatch({type:'set_process_explorer_active_filters',value:activeFilters});
    }

    const handleSetSelectedView = (parent, view, sec = null) => {
        switch (parent) {
            case "averageDuration":
                setSelectedView({...selectedView, averageDuration: view, averageDurationSec: sec});
                break;
            case "caseFrequency":
                setSelectedView({...selectedView, caseFrequency: view});
                break;
            case "rework":
                setSelectedView({...selectedView, rework: view});
                break;
            case "cost":
                setSelectedView({...selectedView, cost: view});
                break;
            default:
                break;
        }
    }

    return (
        <div className={styles.NodeProfile}>
            {
                history.location.pathname === "/process-compare" && data[index].node_side === "both" ?
                    <ProcessCompareNodeProfile
                        data={data}
                        graph={dataGraph.graph}
                        index={index}
                        title={title}
                        filters={filters}
                        views={views}
                        selectedFilter={selectedFilter}
                        selectedView={selectedView}
                        handleSetSelectedFilter={handleSetSelectedFilter}
                        handleSetSelectedView={(parent, view, sec) => handleSetSelectedView(parent, view, sec)}
                        showNodeProfile={showNodeProfile}
                        closeNodeProfile={closeProfile}
                    /> :
                    <ProcessMapNodeProfile
                        data={data}
                        graph={dataGraph.graph}
                        index={index}
                        title={title}
                        level={level}
                        caseFrequency={caseFrequency}
                        filters={filters}
                        views={views}
                        selectedFilter={selectedFilter}
                        selectedView={selectedView}
                        handleSetSelectedFilter={handleSetSelectedFilter}
                        handleSetSelectedView={(parent, view) => handleSetSelectedView(parent, view)}
                        showNodeProfile={showNodeProfile}
                        closeNodeProfile={closeProfile}
                    />
            }
        </div>
    )
}

export default NodeProfile;